import * as React from 'react';
import {Popup} from 'semantic-ui-react';

interface KeyValueViewProps {
    keyNode: React.ReactNode;
    valueNode: React.ReactNode;
    keyWidth?: string;
    keyTooltip?: string;
}

export class KeyValueView extends React.Component<KeyValueViewProps, any> {
    render() {
        const keyWidth = this.props.keyWidth || "100px";
        const key = <div className="key" style={{minWidth: keyWidth, width: keyWidth}}>{this.props.keyNode}</div>;

        return (
            <div className="key-value-view">
                {this.props.keyTooltip == null ?
                    key : (
                        <Popup trigger={key} content={this.props.keyTooltip} position="top center"/>
                    )}
                <div>{this.props.valueNode}</div>
            </div>
        );
    }
}
